<template>
    <div
        class="tip-stripe"
        v-bind:style="{
            color: textColor,
            backgroundColor: backgroundColor,
        }"
    >
        <Icon
            isLocal
            height="32px"
            width="auto"
            iconSource="bulb"
            :fill="textColor"
        />
        <div class="tip-stripe__text">
            {{ text }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'TipStripe',
    props: {
        text: {
            type: String,
            default: 'Lorem ipsum dolorem sit amet',
        },
        textColor: {
            type: String,
            default: '#405260',
        },
        backgroundColor: {
            type: String,
            default: '#e5e5e5',
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/mixins';
@import '@/sass/themes';

.tip-stripe {
    $block: &;
    margin-bottom: 26px;
    padding: 0 16px;
    width: 100%;
    min-height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    column-gap: 16px;
    border-radius: 5px;

    @include mq('tablet') {
        margin-bottom: 30px;
        padding: 0 20px;
    }

    &__text {
        font-size: 14px;
        font-weight: 700;
    }
}
</style>
